import { cn } from "@/lib/utils";
import { ArrowBigUp, ChevronUp, Command, CornerDownLeft } from "lucide-react";
import type { PropsWithChildren } from "react";

const sizes = {
  lg: 16,
  md: 13,
  sm: 10,
};

const ShortcutRoot = ({ children }: PropsWithChildren) => {
  return <div className="flex flex-row gap-0.5 items-center">{children}</div>;
};

const ShortcutCommand = ({
  className,
  size = "md",
}: {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  size?: "lg" | "md" | "sm";
}) => {
  const iconSize = sizes[size];

  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

  return (
    <div className={cn("bg-muted rounded p-1", className)}>
      {isMac ? <Command size={iconSize} /> : <ChevronUp size={iconSize} />}
    </div>
  );
};

const ShortcutHotKey = ({
  children,
  className,
  size = "sm",
}: PropsWithChildren<{
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  size?: "lg" | "md" | "sm";
}>) => {
  const textSize = sizes[size];

  return (
    <div
      className={cn(
        "flex bg-muted rounded w-[21px] h-[21px] justify-center items-center",
        className,
      )}
    >
      <kbd className={`text-[${textSize}px] leading-[2px]`}>{children}</kbd>
    </div>
  );
};

const ShortcutEnter = ({
  className,
  size = "sm",
}: {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  size?: "lg" | "md" | "sm";
}) => {
  const iconSize = sizes[size];

  return (
    <div className={cn("bg-muted rounded p-1", className)}>
      <CornerDownLeft size={iconSize} />
    </div>
  );
};

const ShortcutShift = ({
  className,
  size = "sm",
}: {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  size?: "lg" | "md" | "sm";
}) => {
  const iconSize = sizes[size];

  return (
    <div className={cn("bg-muted rounded p-1", className)}>
      <ArrowBigUp size={iconSize} />
    </div>
  );
};

export const Shortcut = {
  ShortcutRoot,
  ShortcutCommand,
  ShortcutHotKey,
  ShortcutShift,
  ShortcutEnter,
};
